<template>
    <el-dialog
        v-model="dialogVisible"
        title="新增宿舍"
        :before-close="handleClose"
        class="popup_box"
    >
        <el-form :model="form" label-width="auto" style="max-width: 700px">
            <el-form-item label="归属楼栋" prop="region">
                <el-select v-model="form.region" placeholder="选择归属楼栋">
                    <el-option :label="item.name" :value="item.id" v-for="item in BuildingLisst" />
                </el-select>
            </el-form-item>
            <el-form-item label="预设编号" >
                <el-select v-model="form.storey" placeholder="选择楼层">
                    <el-option :label="item.name" :value="item.value" v-for="item in PresetNumber" />
                </el-select>
                <span class="zhong_jian"></span>
                <el-select v-model="form.number" placeholder="开始编号">
                    <el-option :label="item.name" :value="item.value" v-for="item in openNumbering" />
                </el-select>
            </el-form-item>
            <el-form-item label="宿舍列表">
                <div class="dormitory_list_box" >
                    <el-tag
                        v-for="tag in dormList"
                        :key="tag.name"
                        closable
                        @close="tagclose(tag)"
                        :type="tag.type">
                        {{tag.name}}
                        </el-tag>
                        <input
                        placeholder="输入后按<回车>创建"
                        v-model="currentval"
                        @keyup.enter="addTags"
                        @keyup.delete="deleteTags"
                        class="input-tag"
                        ref="inputTag"
                        type="text"
                    />
                </div>
                <div class="add_box" @click="addClick()" >
                    + 添加
                </div>
            </el-form-item>
        </el-form>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="handleClose">取消</el-button>
                <el-button type="primary" @click="preserveClick()">
                确认
                </el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script>
import {
	dormitoryAdd,
    buildingList
} from '@/assets/api/schoollog.js'
import { findTeacherInfo } from '@/assets/api/renyuan';

export default {
    components: {

    },
    data() {
        return {
            dialogVisible: true,
            form: {
                region: '',
                storey: '',
                number: '',
            },
            currentval:'',
            BuildingLisst: [],
            PresetNumber: [
                {
                    name: '1',
                    value: '1',
                },
                {
                    name: '2',
                    value: '2',
                },
                {
                    name: '3',
                    value: '3',
                },
                {
                    name: '4',
                    value: '4',
                },
                {
                    name: '5',
                    value: '5',
                },
                {
                    name: '6',
                    value: '6',
                },
                {
                    name: '7',
                    value: '7',
                },
            ],
            openNumbering: [
                {
                    name: '1',
                    value: '1',
                },
                {
                    name: '2',
                    value: '2',
                },
                {
                    name: '3',
                    value: '3',
                },
                {
                    name: '4',
                    value: '4',
                },
                {
                    name: '5',
                    value: '5',
                },
            ],
            dormList: [],
            storey2: '',
            number2: '',
            xiangdeng: '',
            teacherObj: {}
        };
    },
    created() {
        this.Lookteacher()
    },
    mounted() {

    },
    methods: {
        addTags () {
            // 新增函数中可以加一些你所需要的校验规则。比如只能是数子，或者不能输入‘，’等
            if (!this.currentval.length) return
            console.log('新增111',this.currentval);
            this.dormList.push({
                name: this.currentval,
                id: ''
            })
            this.currentval=''
            this.quChong(this.currentval)

        },
        deleteTags  () {
            console.log('删除');
        },
        Lookteacher() {
         let params = {
            userId: JSON.parse(localStorage.getItem('user')).id,
         }
         findTeacherInfo(params).then((res) => {
            console.log(res, '查看权限');
            this.teacherObj = res.data.data
            this.buildingList()
         }).catch((err) => {
         console.log(err);
         })
      },
        buildingList () {
            let params = {
                name:'',
                page:'1',
                pageSize:'9999',	
                schoolId:this.teacherObj.schoolId,
            }
            buildingList(params).then((res)=> {
                console.log(res,'111111列表接口');
                this.BuildingLisst = res.data.data.list
            })
        },
        preserveClick () {
            if(this.form.region == '' ) return this.$message({type: 'error',message: '请选择楼栋'});
            if(!this.dormList.length ) return this.$message({type: 'error',message: '请选择楼栋'});
            let dormitoryList = []
            for (let item of this.dormList) {
                dormitoryList.push(item.name)
            }
            let params = {
                buildingId: this.form.region,
                dormitoryList,
            }
            dormitoryAdd(params).then((res)=> {
                console.log(res,'保存接口');
                this.$message({
                    message: '宿舍新增保存成功',
                    type: 'success'
                });
                setTimeout(()=> {
                    this.handleClose()
                },1000)
            })
        },

        addClick () {
            // console.log();
            let str = null
            let str2 = null
            if (  this.form.storey == '' || this.form.number == '' ) return this.$message({type: 'error',message: '请选择楼层'});
            if ( this.storey2 == this.form.storey && this.number2 == this.form.number ) {
                console.log('相等');
                for (let item of this.PresetNumber) {
                    if ( item.value ==  this.form.storey) {
                        str = item.name
                    }
                }
                if ( this.xiangdeng != '' ) {
                    this.xiangdeng = Number(this.xiangdeng)+1
                    str2 = this.xiangdeng 
                } else {
                    for (let item of this.openNumbering) {
                        if ( item.value ==  this.form.number) {
                            str2 = Number(item.name )+1
                            this.xiangdeng = Number(item.name )+1
                        }
                    }
                }
                this.dormList.push({
                    name: str + this.padToTwoDigits(str2),
                    id: ''
                })
                this.quChong(str + this.padToTwoDigits(str2))
            } else if (  this.form.storey != '' && this.form.number != ''){
                 this.xiangdeng = '' 
                for (let item of this.PresetNumber) {
                    if ( item.value ==  this.form.storey) {
                        str = item.name
                        this.storey2 = this.form.storey
                    }
                }
                for (let item of this.openNumbering) {
                    if ( item.value ==  this.form.number) {
                        str2 = item.name
                        this.number2 = this.form.number
                    }
                }
                console.log(str + this.padToTwoDigits(str2));
                this.dormList.push({
                    name: str + this.padToTwoDigits(str2),
                    id: ''
                })
                this.quChong(str + this.padToTwoDigits(str2))
            }
            
        },
        padToTwoDigits(num) {
            return num.toString().padStart(2, '0'); // 确保数字至少为2位，不足时前面补0
        },
        quChong (strNumber) {
            // this.dormList =  this.dormList.filter((item, index) => this.dormList.indexOf(item) === index);
            this.dormList = this.dormList.filter((item, index, self) =>
                index === self.findIndex(t => t.name === item.name)
            );
        },
        tagclose (item) {
            console.log('删除',item);
            this.dormList.splice(this.dormList.indexOf(item), 1);
            this.xiangdeng = ''
        },
        handleClose ( ) {
            // this.dialogVisible = false
            this.$emit('handleClose')
        }
    },
};
</script>

<style scoped lang="scss">

.popup_box {
    // width: 800px;

    .el-form {
        padding:0px 20px;
    }
    .zhong_jian {
        display: inline-block;
        width: 20px;
    }
    .dormitory_list_box {
        width: 84%;
        padding: 10px;
        border: 1px solid #FFEBEB;
        min-height: 200px;
        .tag_box {
            padding: 2px 4px;
            margin-right: 6px;
        }
        .el-tag.el-tag--primary {
            background-color: #33CABB;
            color: #fff;
            height: 25px;
            margin-right: 6px;
        }
        :deep(.el-tag .el-tag__close) {
            color: #fff;
            margin-left: 4px
        }
    }
    .add_box {
        color: #fff;
        padding: 3px 6px;
        border-radius: 3px;
        background-color: #0AB1A1;
        margin-left: 10px;
        cursor: pointer;
    }

    .input-tag {
        font-size: 16px;
        border: none;
        box-shadow: none;
        outline: none;
        background-color: transparent;
        padding: 0;
        flex-grow: 1;
        vertical-align: top;
        height: 30px;
        color: #495060;
        line-height: 32px;
    }
}

:deep() {
    .el-select__wrapper {
        height: 35px;
        width: 140px;
        line-height: 35px

    }
    .el-select {
        width: inherit;
    }
    .el-form-item--small .el-form-item__label {
        height: 35px;
        line-height: 35px;
        padding-right: 30px;
    }
    .el-select--small .el-select__wrapper {
        line-height: 35px;
    }
}
</style>
